module.exports = __webpack_public_path__ + "static/media/wooden_staff.f6cb3714.png";